(() => {
  // Shows the quote/video follow-ups only when they apply. Hidden groups are
  // disabled so the browser neither validates nor submits them; without this
  // script every field stays visible and the follow-ups stay optional.
  const init = (form) => {
    if (form.dataset.pnReady) return;
    form.dataset.pnReady = 'true';

    const groups = form.querySelectorAll('[data-pn-show]');
    const value = (name) => form.querySelector(`[name="${name}"]:checked`)?.value;

    const update = () => {
      const wantsTestimonial = value('contact[Testimonial]') === 'Yes';
      const type = value('contact[Testimonial type]');
      const visible = {
        testimonial: wantsTestimonial,
        quote: wantsTestimonial && type === 'Quote',
        video: wantsTestimonial && type === 'Video',
      };

      groups.forEach((group) => {
        const on = visible[group.dataset.pnShow];
        group.hidden = !on;
        group.querySelectorAll('input, textarea').forEach((field) => {
          field.disabled = !on;
          if (field.hasAttribute('data-pn-required')) field.required = on;
        });
      });
    };

    form.addEventListener('change', update);
    update();
  };

  const initAll = (root) => root.querySelectorAll('[data-pn-form]').forEach(init);

  initAll(document);
  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
